module.exports = __webpack_public_path__ + "img/tasks.79498f3a.svg";